import { ORC_RIG_VERSION, morphOrcProportions, orcProportions, orcStandardHeight } from '../../../content/characters/rigs/orc.js';
import type { UnitDefinition } from '../../../shared/game/world-types.js';
import { createHumanoidModel, type HumanModelOptions } from './human-model.js';
import { orcTusks } from './orc-head.js';
import { mix } from '../../../content/characters/rigs/human.js';

export function createOrcModel(definition: UnitDefinition, options?: HumanModelOptions) {
  const look = definition.appearance;
  if (!look || look.ancestry !== 'orc') throw new Error('The Orc model requires Orc appearance content.');
  const p = morphOrcProportions(orcProportions(look.rig), look.parts?.face);
  const rig = createHumanoidModel({ ...definition, appearance: { ...look, height: look.height ?? orcStandardHeight(p.id) } }, p,
    options, { face: p.face, features: effective => orcTusks(effective, p.faceMorph),
      palette: { eye: 0xa97b32, lips: mix(look.skin, 0x3d472d, .45) } });
  rig.root.userData.nimblezRigVersion = ORC_RIG_VERSION;
  return rig;
}
